import { useEffect } from 'react';

type UseTriggerDhcpValueValidation = {
  trigger: (
    name?: keyof RemoteAccessFormData | (keyof RemoteAccessFormData)[],
  ) => Promise<boolean>;
  watchDhcpType: DhcpTypes;
};

export const useTriggerDhcpValueValidation = ({
  trigger,
  watchDhcpType,
}: UseTriggerDhcpValueValidation): void => {
  useEffect(() => {
    trigger('dhcpValue');
  }, [trigger, watchDhcpType]);
};
